/* eslint-disable react/display-name */
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Drawer,
  Input,
  RangeDatePicker,
  Row,
  Select,
  Table
} from '../../core/components'
import { Link } from 'react-router-dom'
import { routesConfig } from '../../core/configs/routes'
import { FilterOutlined } from '@ant-design/icons'
import { ChangeEvent, useEffect, useState } from 'react'
import { City, ContractFilter, Pagination } from '../../entities'
import useContracts from '../../services/queries/contract/useContracts'
import { Select as AntdSelect } from 'antd'
import { dateFormat } from '../../utils/format/dateFormat'
import useCities from '../../services/queries/useCities'
import useStates from '../../services/queries/useStates'
import { State } from '../../entities/state'
import { situationControl } from '../../core/utils/situationConst'

const { Option } = AntdSelect

function getSituationControl(key: any) {
  return situationControl[key]
}

const columns = [
  {
    title: 'Nº Contrato',
    dataIndex: 'id',
    key: 'id',
    render: (value: any, row: any) => {
      return (
        <Link
          to={routesConfig.contracts.contract.datails + `/${row.id}/detalhes`}
        >
          {value}
        </Link>
      )
    }
  },
  {
    title: 'Descrição',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: 'Situação',
    dataIndex: 'situation',
    key: 'situation',
    render: (value: any) => {
      return getSituationControl(value)
    }
  },
  {
    title: 'Data Início',
    dataIndex: 'startDate',
    key: 'startDate',
    render: (value: string) => dateFormat(value)
  },
  {
    title: 'Data Final',
    dataIndex: 'endDate',
    key: 'endDate',
    render: (value: string) => dateFormat(value)
  }
]

export const situation = [
  { id: 'A', name: 'ATIVO' },
  { id: 'C', name: 'CANCELADO' },
  // { id: 'E', name: 'BLOQ. ADMINISTRATIVO' },
  { id: 'S', name: 'SUSPENSO' },
  { id: 'P', name: 'PENDENTE' },
  { id: 'M', name: 'BLOQ. FINANCEIRO' },
  { id: 'R', name: 'CORTESIA' }
]

export const ContractsPage = () => {
  const [showFilter, setShowFiler] = useState<boolean>(false)
  const { data: states, isLoading: isStatesLoading } = useStates()

  const handleShowFilter = () => {
    setShowFiler((prev: boolean) => !prev)
  }

  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const [filters, setFilters] = useState<ContractFilter>({
    id: '',
    description: '',
    situationId: '',
    startDate: '',
    endDate: '',
    search: '',
    state: '',
    city: ''
  })
  const [filterState, setFilterState] = useState<ContractFilter>({
    id: '',
    description: '',
    situationId: '',
    startDate: '',
    endDate: '',
    search: '',
    state: '',
    city: ''
  })

  const { data: cities, isLoading: isCitiesLoading } = useCities({
    page: 1,
    limit: 9999,
    filters: { state: filterState?.state }
  })

  const { data, isLoading, isFetching, isPreviousData } = useContracts({
    ...pagination,
    filters
  })

  const handleStateClear = () => {
    setFilterState((prev) => ({ ...prev, state: '', municipio: '' }))
    setFilters((prev) => ({ ...prev, state: '', municipio: '' }))
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterState((prev: ContractFilter) => ({
      ...prev,
      search: e.target.value.toUpperCase()
    }))
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const handleReset = () => {
    setFilterState({
      id: '',
      description: '',
      situationId: '',
      startDate: '',
      endDate: '',
      search: '',
      state: '',
      city: ''
    })
    setFilters({
      id: '',
      description: '',
      situationId: '',
      startDate: '',
      endDate: '',
      search: '',
      state: '',
      city: ''
    })
  }

  const handleSituationClear = () => {
    setFilters((prev) => ({ ...prev, situation: '' }))
    setFilterState((prev) => ({ ...prev, situation: '' }))
  }

  useEffect(() => {
    if (filterState.search === '')
      setFilters((prev) => ({ ...prev, search: '' }))
  }, [filterState.search])

  useEffect(() => {
    if (filterState.id === '') setFilters((prev) => ({ ...prev, id: '' }))
  }, [filterState.id])

  useEffect(() => {
    if (filterState.description === '')
      setFilters((prev) => ({ ...prev, description: '' }))
  }, [filterState.description])

  const handleCityClear = () => {
    setFilterState((prev) => ({ ...prev, municipio: '' }))
    setFilters((prev) => ({ ...prev, municipio: '' }))
  }

  const onSearch = (value: any) => {
    return value
  }

  const handleDateClear = () => {
    console.log('clearDate')
    setFilters((prev) => ({
      ...prev,
      startDate: '',
      endDate: ''
    }))
    setFilterState((prev) => ({
      ...prev,
      startDate: '',
      endDate: ''
    }))
  }

  return (
    <>
      <ContentHeader>Contratos</ContentHeader>
      <ContentBody>
        <Row style={{ marginBottom: 10 }}>
          <Col>
            <Input
              allowClear
              value={filterState.search}
              placeholder="Pesquisar"
              style={{ width: '385px', marginBottom: 20, marginRight: 20 }}
              onChange={(e) => handleSearch(e)}
              onPressEnter={() => setFilters(filterState)}
            />
          </Col>
          <Col>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: 100 }}
              onClick={() => setFilters(filterState)}
            >
              Procurar
            </Button>
            <Button style={{ marginLeft: 10 }} onClick={handleReset}>
              Reiniciar
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={handleShowFilter}
              icon={<FilterOutlined />}
            >
              Filtros
            </Button>
          </Col>
        </Row>
        <Table
          loading={(isLoading || isFetching) && isPreviousData}
          dataSource={data?.data}
          columns={columns}
          bordered
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
          rowKey={(row) => row.num_oportunity}
        />
        <Drawer
          title="Filtros"
          width={520}
          closable={false}
          onClose={handleShowFilter}
          visible={showFilter}
          footer={
            <div
              style={{
                textAlign: 'right',
                paddingBottom: 30,
                paddingTop: 30
              }}
            >
              <Button
                onClick={() => {
                  handleReset()
                  handleShowFilter()
                }}
                style={{ marginRight: 8 }}
              >
                Reiniciar
              </Button>
              <Button
                onClick={() => {
                  setFilters(filterState)
                  handleShowFilter()
                }}
                type="primary"
              >
                Aplicar
              </Button>
            </div>
          }
        >
          <div>
            <Row>
              <Col span={24}>
                <Select
                  label="Situação"
                  placeholder="Selecione..."
                  allowClear
                  showSearch
                  loading={isLoading}
                  onClear={handleSituationClear}
                  value={filterState?.situationId || null}
                  onSelect={(situationId) =>
                    setFilterState((prev) => ({
                      ...prev,
                      situationId
                    }))
                  }
                >
                  {situation?.map((type: any) => (
                    <Option key={type.id} value={type.id}>
                      {type.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Select
                  label="Estado"
                  placeholder="Selecione..."
                  showSearch
                  onSearch={onSearch}
                  loading={isStatesLoading}
                  allowClear
                  onClear={handleStateClear}
                  value={filterState.state || null}
                  filterOption={(input, option) => {
                    if (typeof option?.children === 'string') {
                      return (
                        option?.children
                          ?.toUpperCase()
                          .indexOf(input.toUpperCase()) >= 0
                      )
                    }
                    return false
                  }}
                  onSelect={(state: string) =>
                    setFilterState((prev: ContractFilter) => ({
                      ...prev,
                      state,
                      city: ''
                    }))
                  }
                >
                  {states?.data?.map((state: State) => (
                    <Option key={state.id} value={state.id}>
                      {`${state.id} - ${state.name}`}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Select
                  label="Município"
                  showSearch
                  onSearch={onSearch}
                  loading={isCitiesLoading}
                  allowClear
                  onClear={handleCityClear}
                  placeholder="Selecione..."
                  value={filterState.city || null}
                  filterOption={(input, option) =>
                    option?.children
                      .toUpperCase()
                      .indexOf(input.toUpperCase()) >= 0
                  }
                  onSelect={(city: string) =>
                    setFilterState((prev: ContractFilter) => ({
                      ...prev,
                      city
                    }))
                  }
                >
                  {cities?.data?.map((city: City) => (
                    <Option key={city.id} value={city.id}>
                      {city.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <RangeDatePicker
                  label="Data Incial e Final"
                  format={'DD/MM/YYYY'}
                  // onOk={onOk}
                  allowClear
                  placeholder={['Selecione', 'Selecione']}
                  onClear={handleDateClear}
                  onChange={(e: any) => {
                    if (!e) handleDateClear()
                    setFilterState((prev) => ({
                      ...prev,
                      startDate: e?.[0] || '',
                      endDate: e?.[1] || ''
                    }))
                  }}
                />
              </Col>
            </Row>
          </div>
        </Drawer>
      </ContentBody>
    </>
  )
}
